var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4714)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27.75H20.2C16.78 27.75 15.25 26.22 15.25 22.8V19.2C15.25 15.78 16.78 14.25 20.2 14.25H23.8C27.22 14.25 28.75 15.78 28.75 19.2V23C28.75 23.41 28.42 23.74 28.01 23.75C25.61 23.79 24.79 24.62 24.75 27.01C24.74 27.42 24.41 27.75 24 27.75ZM20.2 15.75C17.62 15.75 16.75 16.62 16.75 19.2V22.8C16.75 25.38 17.62 26.25 20.2 26.25H23.29C23.53 23.81 24.81 22.54 27.25 22.29V19.2C27.25 16.62 26.38 15.75 23.8 15.75H20.2Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 19.6301C18.97 19.6301 18.73 19.5202 18.59 19.3102C18.35 18.9702 18.43 18.5001 18.77 18.2601C19.55 17.7101 20.6 17.7001 21.39 18.2401C21.73 18.4701 21.82 18.9402 21.59 19.2802C21.36 19.6202 20.89 19.7101 20.55 19.4801C20.28 19.3001 19.92 19.3001 19.65 19.4901C19.5 19.5901 19.35 19.6301 19.2 19.6301Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2 19.6301C22.97 19.6301 22.73 19.5202 22.59 19.3102C22.35 18.9702 22.43 18.5001 22.77 18.2601C23.55 17.7101 24.6 17.7001 25.39 18.2401C25.73 18.4701 25.82 18.9402 25.59 19.2802C25.36 19.6202 24.89 19.7101 24.55 19.4801C24.28 19.3001 23.92 19.3001 23.65 19.4901C23.5 19.5901 23.35 19.6301 23.2 19.6301Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1598 25.1702H19.8398C19.1298 25.1702 18.5498 24.5901 18.5498 23.8801C18.5498 21.9801 20.0998 20.4302 21.9998 20.4302C22.7798 20.4302 23.5498 20.7001 24.1598 21.1901C24.4798 21.4501 24.5398 21.9201 24.2798 22.2401C24.0198 22.5601 23.5498 22.6101 23.2298 22.3601C22.8798 22.0801 22.4598 21.9302 22.0098 21.9302C21.0098 21.9302 20.1798 22.6902 20.0698 23.6702H22.1698C22.5798 23.6702 22.9198 24.0102 22.9198 24.4202C22.9198 24.8302 22.5698 25.1702 22.1598 25.1702Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8 35.75H28.2C24.78 35.75 23.25 34.22 23.25 30.8V27C23.31 23.81 24.81 22.31 27.99 22.25H31.8C35.22 22.25 36.75 23.78 36.75 27.2V30.8C36.75 34.22 35.22 35.75 31.8 35.75ZM28 23.75C25.62 23.79 24.79 24.62 24.75 27.01V30.8C24.75 33.38 25.62 34.25 28.2 34.25H31.8C34.38 34.25 35.25 33.38 35.25 30.8V27.2C35.25 24.62 34.38 23.75 31.8 23.75H28Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.09 27.6301C27.62 27.6301 27.16 27.4901 26.77 27.2101C26.43 26.9701 26.35 26.5002 26.59 26.1602C26.83 25.8202 27.3 25.7401 27.64 25.9801C27.91 26.1701 28.27 26.1701 28.54 25.9901C28.88 25.7601 29.35 25.8401 29.58 26.1901C29.81 26.5301 29.73 27.0001 29.38 27.2301C28.99 27.5001 28.54 27.6301 28.09 27.6301Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.09 27.6301C31.62 27.6301 31.16 27.4901 30.77 27.2101C30.43 26.9701 30.35 26.5002 30.59 26.1602C30.83 25.8202 31.3 25.7401 31.64 25.9801C31.91 26.1701 32.27 26.1701 32.54 25.9901C32.88 25.7601 33.35 25.8401 33.58 26.1901C33.81 26.5301 33.73 27.0001 33.38 27.2301C32.99 27.5001 32.54 27.6301 32.09 27.6301Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 33.1702C28.0998 33.1702 26.5498 31.6201 26.5498 29.7201C26.5498 29.0101 27.1298 28.4302 27.8398 28.4302H32.1598C32.8698 28.4302 33.4498 29.0101 33.4498 29.7201C33.4498 31.6201 31.8998 33.1702 29.9998 33.1702ZM28.0598 29.9302C28.1598 30.9102 28.9898 31.6702 29.9998 31.6702C31.0098 31.6702 31.8298 30.9102 31.9398 29.9302H28.0598Z",
    fill: "#394455"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4714",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4714",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/expert.47f2df6d3be650ad125d718fe93f4102.svg";
export { ForwardRef as ReactComponent };